import React, { useMemo, useCallback } from 'react';
import { useApp } from '@dex/bubl-dash/src/lib/functions/useApp';
import { useForm } from '@dex/bubl-dash/src/lib/functions/useForm';
import { Row, Col, Space } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import LeagueSeasonApi from '../LeagueSeasonApi';
import LeagueSeasonCreateEditForm from './LeagueSeasonCreateEditForm';
import LeagueSeasonSettingsForm from './LeagueSeasonSettingsForm';

const LeagueSeasonSingleEdit: React.FC<any> = (props: any) => {

    const app = useApp();

    const { data } = props;

    const form = useForm(data);

    const update = LeagueSeasonApi.update(data.id, "update", {
        onComplete: (data) => {

            app.alert('League Season Saved', 'success');

        }
    });

    const handleSubmit = useCallback((values) => {

        update.run({ data: values });

    }, [props]);

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <LeagueSeasonCreateEditForm
                    mode={"edit"}
                    form={form}
                    data={data}
                    handleSubmit={handleSubmit}
                    process={update}
                />

                <Space />

                <LeagueSeasonSettingsForm
                    data={data}
                />

            </Col>

        </Row>

    ), [data, form, update]);

}

export default LeagueSeasonSingleEdit;
